module.exports = __webpack_public_path__ + "img/slideVerify_15.68843e1f.png";